import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from "@angular/material/dialog";
import moment from 'moment';
import { SubSink } from 'subsink';
import { SharedModule } from '@Shared/shared.module';
import { AppService } from 'app/app.service';
import { UserAdminService, TeamsService } from 'app/services';
import { ActionsEntity, TableColumnDefinition } from 'app/shared/components/mrs-table/models/table-models';
import { CreateTeamComponent } from '../create-team/create-team.component';
import { teamsTableComponent } from './teams-table.component';
import { GetManageTeamsResponse } from '../../models/get-manage-teams-response.interface';
import { RouterModule } from '@angular/router';

@Component({
  selector: "app-teams",
  host: { 'class': 'content' },
  templateUrl: "./app-teams.component.html",
  styleUrls: ["./app-teams.component.scss"],
  imports: [SharedModule, teamsTableComponent, RouterModule]
})
export class AppTeamsComponent implements OnDestroy, OnInit{
  canRead = false;
  canWrite = false;
  full = false;
  hasMultipleClients = false;
  // clientSelectListItems: MultiSelectModel[];
  addRecordAction: ActionsEntity;
  disableUserAction: ActionsEntity;
  searchableFields: string[];
  displayedColumns: TableColumnDefinition[];
  private subs = new SubSink();
  teams: any;
  createTeamDialogRef: MatDialogRef<CreateTeamComponent>;

  constructor(
    private appService: AppService,
    private teamsService: TeamsService,
    private userAdminService: UserAdminService
  ) { }

  ngOnInit(): void {
    this.canRead = this.appService.checkACL('Manage Teams', 'R');
    this.canWrite = this.appService.checkACL('Manage Teams', 'W');
    this.full = this.appService.checkACL('Manage Teams', 'F');
    this.getTeams();
    this.setupTableInputs();
  }

  setupTableInputs() {
    this.addRecordAction = { actionType: 'add', name: 'CREATE TEAM', permission: this.canWrite };
    this.disableUserAction = { actionType: 'disable', name: 'Disable Team', permission: this.canWrite };

    this.searchableFields = ['name', 'userRoleName'];
    this.displayedColumns = [
      {
        def: 'name',
        header: 'Team Name',
        sortFields: ['name'],
        columnStyles: {
          'width': '20%',
        },
        rowDefs: [
          {
            className: '',
            dataName: 'name',
          }
        ]
      },
      {
        def: 'activeCase',
        header: 'Active Cases',
        sortFields: ['activeCase'],
        columnStyles: {
          'width': '20%'
        },
        rowDefs: [
          {
            className: '',
            dataName: 'activeCase'
          }
        ]
      },
      {
        def: 'activeMembers',
        header: 'Members',
        sortFields: ['activeMembers'],
        columnStyles: {
          'width': '20%'
        },
        rowDefs: [
          {
            className: '',
            dataName: 'activeMembers'
          }
        ]
      },
      {
        def: 'creationDate',
        header: 'Created',
        sortFields: ['creationDate'],
        columnStyles: {
          'width': '20%'
        },
        rowDefs: [
          {
            className: '',
            dataName: 'creationDate'
          }
        ]
      },         
      {
        def: 'actions',
        header: '',
        columnStyles: {
          'width': '25%'
        },
        isAction: true,
        actions: [
          {
            name: 'View Teams',
            icon: 'square-edit-outline',
            actionType: 'view',
            permission: this.canWrite
          },
        ]
      }
    ];
  }

  reloadTeams(event) {
    if (event) {
      this.getTeams();
    }
  }

  getTeams() {
    this.subs.add(this.userAdminService.getAllTeams().subscribe(data => {
      this.teams = data.map((team: GetManageTeamsResponse) => ({
        ...team,
        id: team.id,
        name: team.name,
        activeMembers: team.activeMembers,
        activeCase: team.activeCasesCount,
        creationDate: moment(team.creationDate).utc().format('l') === '1/1/0001' ? '' : moment(team.creationDate).utc().format('l')               
      }));
    }));
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
